export interface RefreshGrantModel {
  refresh_token: string;
}
